import { useAbility } from '@cast/shared-ability-data-access';

export const useIsSecuritySunsetEnabled = () => {
  return useAbility().can('view', 'FeatureSecuritySunset');
};
